export default __webpack_public_path__ + "static/hb-a-1-c-box@2x-d8ba52f690da1fe144775cbc9eaec0b0.png";